import classNames from "classnames";

import Icon from "app/components/shared/Icon";

const variants = {
  warning: {
    title: "Unresolved step dependencies",
    body: "This step is waiting for the following dependencies to resolve before running, but they do not currently appear in the pipeline:",
    icon: "heroicons/16/solid/exclamation-triangle",
    borderColor: "border-orange-500",
    bgColor: "bg-orange-100",
    iconColor: "text-orange-500",
  },
  error: {
    title: "Step dependencies not found",
    body: "The following step dependencies were not found during the build:",
    icon: "heroicons/16/solid/x-mark",
    borderColor: "border-red-500",
    bgColor: "bg-red-500",
    iconColor: "text-white",
  },
};

export function MissingStepDependencies({
  variant = "warning",
  dependencies,
}: {
  variant?: keyof typeof variants;
  dependencies: string[];
}) {
  const { borderColor, bgColor, icon, iconColor, title, body } =
    variants[variant];

  return (
    <div
      className={classNames("border rounded flex overflow-hidden", borderColor)}
    >
      <div
        className={classNames(
          "w-8 flex-shrink-0 flex justify-center border-r pt-4",
          borderColor,
          bgColor,
        )}
      >
        <Icon icon={icon} className={classNames("w-4 h-4", iconColor)} />
      </div>

      <div className="px-4 py-3 flex-grow">
        <h3 className="text-base mt-0 mb-2">{title}</h3>

        <p className="mt-0 mb-3">{body}</p>

        <ul className="divide-y depth rounded max-w-lg mb-3">
          {dependencies.map((dependency) => (
            <li
              key={dependency}
              className="monospace border-gray-300 text-xs p-2.5 m-0"
            >
              {dependency}
            </li>
          ))}
        </ul>

        <p className="m-0">
          Check the pipeline is configured correctly, or see the{" "}
          <a
            href="/docs/pipelines/dependencies"
            className="text-inherit underline"
          >
            documentation
          </a>
          .
        </p>
      </div>
    </div>
  );
}
